<template>
  <div id="themeList_output" v-show="currThemeObj">
    <div
      class="themeList"
      ref="themeContainer"
      :class="isBatchChoose ? 'choose' : ''"
    >
      <div
        v-show="themeList && themeList.length > 0"
        class="themeContain"
        v-for="item in themeList"
        :key="item.dataItemId"
        :class="
          width100ThemeGraphicsIds.includes(item.graphicsId)
            ? width100ThemeGraphicsIdsClassName[
                width100ThemeGraphicsIds.indexOf(item.graphicsId)
              ]
            : ''
        "
      >
        <div
          class="themeContain_item"
          @click="chooseStatusClickFunc(item)"
          :class="[
            item.isChooseAct ? 'chooseAct' : '',
            isBatchChoose ? 'showChoose' : '',
          ]"
        >
          <slot name="itemClose" :item="item"></slot>
          <div class="theme_header">
            <div
              class="header_btnArea"
              :class="item.isMediaBroadcastFlag ? 'slideR2L' : 'slideL2R'"
            >
              <slot name="itemBtnAreaLeft" :item="item"></slot>
              <slot name="itemBtnAreaRight" :item="item"></slot>
            </div>
          </div>
          <compreSportsMeet_themeItem
            :currThemeObj="currThemeObj"
            :themeItem="item"
            :width100ThemeGraphicsIds="width100ThemeGraphicsIds"
            :width100ThemeGraphicsIdsClassName="
              width100ThemeGraphicsIdsClassName
            "
            mode="broadcastList"
          ></compreSportsMeet_themeItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import compreSportsMeet_themeItem from '@components/platfromBase/compreSportsMeet/themeItem.vue'
export default {
  name: 'themeList_output',
  mixins: [cup_base_data_mixin],
  components: {
    compreSportsMeet_themeItem,
  },
  props: {
    themeList: {
      type: [Array, null],
      default: null,
    },
    currThemeType: {
      type: Object,
      default: () => ({}),
    },
    isBatchChoose: {
      //控制所有主题上是否显示多选按钮
      type: Boolean,
      default: false,
    },
    chooseStatusClickFunc: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    currThemeType: {
      handler(newVal, oldVal) {
        if (newVal) {
          console.debug('currThemeType 刷新数据:', newVal, oldVal)
          if (newVal.id === 'broadcast') {
            this.width100ThemeGraphicsIds = []
            this.width100ThemeGraphicsIdsClassName = []
          } else {
            this.width100ThemeGraphicsIds = this.org_width100ThemeGraphicsIds
            this.width100ThemeGraphicsIdsClassName =
              this.org_width100ThemeGraphicsIdsClassName
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      //   themeList: null,
      org_width100ThemeGraphicsIds: [
        8, 11, 23, 24, 26, 37, 38, 39, 3000, 3014, 3015, 3016, 3018, 3019, 3023,
        3024, 3025, 3027, 3029, 2001, 2007, 2010, 2012, 4001, 4003, 4004, 4006,
        4007, 4008, 4009,
      ],
      org_width100ThemeGraphicsIdsClassName: [
        'width100', //8(足球 双方首发阵容)
        'width100', //11(足球小组赛积分榜)
        'width100', //23(足球晋级图)
        'width100', //24(足球 单个球队首发阵容)
        'width100', //26(足球阵容)
        'width100 fillPer100', //37(足球-双方球员评分)
        'width100 height27s5vw mtb1388', //38(【足球世界杯】今日赛程)
        'width100 height27s5vw mtb1388', //39(【足球世界杯】赛程预告)
        'width100', //3000(奖牌榜)
        'width100 height27s5vw mtb1388', //3014(今日赛程)
        'width100 height27s5vw borderR694 mtb1388', //3015(今日奖牌)
        'width100', //3016(双方首发阵容 表格类型)
        'width100', //3018(小组赛积分榜)
        'width100 height27s5vw mtb1388', //3019(分项运动员赛程)
        'width100 mtb1388', //3023(单个或多个国家的奖牌榜)
        'width100 mtb1388', //3024(赛程预告)
        'width100 mtb1388', //3025(综合性赛事 对抗类淘汰赛)
        'width100 height31vw mtb1388', //3027(复杂表格 比如【混合团体10米气手枪资格赛】)
        'width100 mtb1388', //3029(综合性赛事 对抗类 中网 表格 晋级之路)
        'width100', //2001(联赛球队排名 基本同11)
        'width100', //2007(cba晋级图)
        'width100', //2010(cba晋级图)
        'width100', //3016(双方首发阵容 表格类型)
        'width100', //4001(羽毛球【汤尤杯】积分榜)
        'width100 height27s5vw mtb1388', //4003(节目单)
        'width100', //4004(羽毛球【汤尤杯】运动员对阵)
        'width100 mtb1388', //4006(羽毛球【汤尤杯】赛程预告)
        'width100 height27s5vw mtb1388', //4007(羽毛球【汤尤杯】今日赛程)
        'width100 themeContainH28vw', //4008(羽毛球【汤尤杯】双方出场名单)
        'width100', //4009(羽毛球【汤尤杯】赛果里面的比赛详情)
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
#themeList_output {
  --outsideRadiusSize: 0.694vw;
  --insideRadiusSize: 0.533vw;
  --insidePadSize: 0.32vw;
  .themeList {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    padding-top: 2.083vw;
    width: 100%;
    &.choose {
      .item_absChoose {
        width: 2.776vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .checkbox_item {
          width: 1.388vw;
          height: 1.388vw;
          border-radius: 0.208vw;
          border: 1px solid var(--mixtmt_subColor1_1);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_whiteColor);
          /* &.act {
                    background-color: var(--mixtmt_subColor1_1);
                    color: var(--mixtmt_whiteColor);
                  } */
          svg {
            opacity: 0;
            fill: var(--mixtmt_whiteColor);
            transition: all 0.3s linear;
          }
        }
      }
      & .chooseAct {
        .checkbox_item {
          background-color: var(--mixtmt_subColor1_1);
          svg {
            opacity: 1;
          }
        }
      }
    }
    .item_absChoose {
      display: none;
    }
    .themeContain {
      width: calc((100% - 1.388vw) / 2);
      height: auto;
      margin-bottom: 1.388vw;
      &.width100 {
        width: 100%;
        height: auto;
      }
      .themeContain_item {
        position: relative;
        width: 100%;
        /* padding-top: 61.5%; */
        /* background-color: var(--mixtmt_greyColor7); */
        transition: all 0.15s linear;
        border: 1px solid var(--mixtmt_greyColor7);
        border-radius: var(--outsideRadiusSize);
        .theme_header {
          width: 100%;
          height: auto;
          background-color: var(--mixtmt_greyColor12);
          border-radius: var(--outsideRadiusSize) var(--outsideRadiusSize) 0 0;
          overflow: hidden;
          .header_btnArea {
            position: relative;
            width: 100%;
            height: 4vw;
          }
        }
        &.act:not(.showChoose) {
          border: 1px solid var(--mixtmt_mainColor6);
          box-shadow: 0 2px 0.972vw 0 var(--mixtmt_greyColor0);
          .themeContainItem_close {
            display: flex;
            display: -webkit-flex;
          }
        }
        &.act {
          border: 1px solid var(--mixtmt_mainColor6);
          box-shadow: 0 2px 0.972vw 0 var(--mixtmt_greyColor0);
        }
        .themeContainItem_close {
          display: none;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: -1.04vw;
          right: -1.04vw;
          z-index: 10;
          width: 2.08vw;
          height: 2.08vw;
          border-radius: 50%;
          background-color: var(--mixtmt_greyColor2);
          font-size: 0.972vw;
          font-weight: bold;
          color: var(--mixtmt_whiteColor);
        }
        .themeContainItem_btnArea {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          position: absolute;
          top: 1vw;
          z-index: 10;
          width: 50%;
          height: auto;
          &.right {
            justify-content: flex-end;
            right: 0.694vw;
          }
          &.left {
            justify-content: flex-start;
            left: 0.694vw;
          }
          .btnGroup {
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .btnItem {
              width: auto;
              font-size: 0.972vw;
              line-height: calc(2.083vw - 2px);
              background-color: var(--mixtmt_whiteColor);
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor7);
              padding: 0 0.833vw;
              &:first-child {
                border-radius: 1.389vw 0 0 1.389vw;
                border-right: 0;
              }
              &:last-child {
                border-radius: 0 1.389vw 1.389vw 0;
                border-left: 0;
              }
              &.act {
                background-color: var(--mixtmt_mainColor8);
                color: var(--mixtmt_whiteColor);
              }
            }
          }
          .btnArea_edit {
            margin-right: 0.694vw;
            padding: 0 0.833vw;
            height: 2.083vw;
            /* height: 1.736vw; */
            font-size: 0.972vw;
            line-height: calc(2.083vw - 2px);
            border-radius: 1.389vw;
            background-color: var(--mixtmt_whiteColor);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor7);
          }
          .paddingR10 {
            padding-right: 0.694vw;
          }
        }
      }
    }
  }
}
.mixtmt_pc #themeList_output {
  .themeList {
    .themeContain {
      .themeContain_item {
        /* cursor: pointer; */
        &:hover {
          border: 1px solid var(--mixtmt_mainColor6);
          box-shadow: 0 calc(1px + 1px) 0.972vw 0 var(--mixtmt_greyColor0);
          &:not(.showChoose) .themeContainItem_close {
            display: flex;
            display: -webkit-flex;
            &:hover {
              cursor: pointer;
              background-color: var(--mixtmt_greyColor3);
            }
          }
          &.showChoose {
            &:hover {
              cursor: pointer;
            }
          }
        }
        .themeContainItem_btnArea {
          .btnGroup {
            .btnItem {
              cursor: pointer;
              &:hover {
                background-color: var(--mixtmt_mainColor8);
                color: var(--mixtmt_whiteColor);
              }
            }
          }
          .btnArea_edit {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor8);
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
  }
}
</style>
